document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-size-unit]');
  if (!button) return;
  const guide = button.closest('[data-satri-size-guide]');
  if (!guide) return;
  const inches = button.dataset.sizeUnit === 'in';
  guide.querySelectorAll('[data-size-unit]').forEach((item) => {
    const active = item === button;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-pressed', String(active));
  });
  guide.querySelectorAll('[data-cm], [data-cm-range]').forEach((cell) => {
    const values = (cell.dataset.cmRange || cell.dataset.cm).split(':');
    cell.textContent = inches
      ? values.map((cm) => (Number(cm) / 2.54).toFixed(1)).join('–')
      : values.join('–');
  });
});
